<template>
  <el-drawer
    title="详情"
    :visible.sync="show"
    size="960px"
    append-to-body
    :wrapper-closable="false"
    custom-class="channel-reserve-detail-drawer"
  >
    <div v-loading="isLoading" class="detail-body">
      <div class="detail-section">
        <div class="detail-section-header">
          <span>商品信息</span>
          <el-button type="text" class="communicate-link" @click="openCommunicateDialog">沟通记录</el-button>
        </div>
        <div class="detail-section-content product-info-content" v-if="reservation">
          <div class="product-preview">
            <div class="product-image">
              <el-image
                v-if="reservation.productMainImage"
                class="image"
                :src="reservation.productMainImage"
                fit="cover"
                :preview-src-list="[reservation.productMainImage]"
              />
              <img v-else src="../../../../../assets/images/default.png" class="image" />
            </div>
          </div>
          <div class="product-info-list">
            <div class="info-row product-name-row">
              <span class="label">商品名称</span>
              <span class="value product-name">{{ reservation.productName || '--' }}</span>
            </div>
            <div class="info-row">
              <span class="label">下单路径</span>
              <span class="value">{{ reservation.salesPathName || '--' }}</span>
            </div>
            <div class="info-row">
              <span class="label">预约数量</span>
              <span class="value">{{ formatDetailReservationQtyText(reservation) }}</span>
            </div>
            <div class="info-row">
              <span class="label">期望佣金</span>
              <span class="value">{{ formatListCommissionText(reservation) }}</span>
            </div>
            <div class="info-row">
              <span class="label">期望下单时间</span>
              <span class="value">{{ reservation.expectedOrderTime || '--' }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="detail-section">
        <div class="detail-section-header">
          <span>SUP部门反馈结果</span>
        </div>
        <div class="detail-section-content feedback-content">
          <el-table border stripe :data="feedbackList">
            <el-table-column type="index" label="序号" width="60" />
            <el-table-column prop="salesPathName" label="下单路径" min-width="100" show-overflow-tooltip />
            <el-table-column prop="sourceOrgName" label="来源机构" min-width="100" show-overflow-tooltip />
            <el-table-column label="可下单量" min-width="100">
              <template slot-scope="{ row }">
                {{ formatFeedbackOrderableText(row) }}
              </template>
            </el-table-column>
            <el-table-column label="佣金" min-width="140">
              <template slot-scope="{ row }">
                {{ formatFeedbackCommissionText(row) }}
              </template>
            </el-table-column>
            <el-table-column prop="orderableTime" label="可下单时间" min-width="160" />
            <el-table-column prop="precautions" label="下单注意事项" min-width="180" show-overflow-tooltip />
            <el-table-column prop="feedbackTime" label="反馈时间" min-width="160" />
          </el-table>
        </div>
      </div>
    </div>

    <div class="drawer-footer">
      <el-button @click="show = false">返回</el-button>
    </div>

    <ReserveRecordCommunicateDialog
      v-model="showCommunicateDialog"
      :record="record"
      source="biz"
    />
  </el-drawer>
</template>

<script>
import ReserveRecordCommunicateDialog from '@/page/component/sections/xpk/sup/reserve-record-communicate-dialog'
import { getBizVolumeDetail } from '@/service/apis/supVolume'
import {
  formatListCommissionText,
  formatDetailReservationQtyText,
  formatFeedbackOrderableText,
  formatFeedbackCommissionText
} from '@/page/component/sections/xpk/sup/sup-volume-fields'

export default {
  name: 'ChannelReserveDetailDrawer',
  components: {
    ReserveRecordCommunicateDialog
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    record: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      isLoading: false,
      reservation: null,
      feedbackList: [],
      showCommunicateDialog: false
    }
  },
  computed: {
    show: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  watch: {
    value(val) {
      if (val) {
        this.loadDetail()
      }
    }
  },
  methods: {
    formatListCommissionText,
    formatDetailReservationQtyText,
    formatFeedbackOrderableText,
    formatFeedbackCommissionText,
    loadDetail() {
      if (!this.record || !this.record.id) {
        this.resetDetail()
        return
      }
      this.isLoading = true
      getBizVolumeDetail.call(this, { id: this.record.id }).then(res => {
        this.reservation = {
          ...(res.reservation || {}),
          productMainImage: (res.reservation && res.reservation.productMainImage)
            || this.record.productMainImage
            || ''
        }
        this.feedbackList = res.feedbackList || []
      }).finally(() => {
        this.isLoading = false
      })
    },
    resetDetail() {
      this.reservation = null
      this.feedbackList = []
    },
    openCommunicateDialog() {
      this.showCommunicateDialog = true
    }
  }
}
</script>

<style scoped>
.detail-body {
  min-height: 200px;
  padding: 0 20px;
  max-height: calc(100vh - 140px);
  overflow-y: auto;
}

.detail-section {
  margin-bottom: 16px;
  border: 1px solid #eee;
  border-radius: 2px;
  overflow: hidden;
}

.detail-section:last-child {
  margin-bottom: 0;
}

.detail-section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 40px;
  padding: 0 16px;
  background-color: #fafafa;
  border-bottom: 1px solid #eee;
  font-size: 14px;
  font-weight: 700;
  color: #333;
}

.communicate-link {
  padding: 0;
  font-size: 14px;
}

.detail-section-content {
  padding: 16px;
}

.product-info-content {
  display: flex;
  align-items: flex-start;
}

.product-preview {
  width: 120px;
  flex-shrink: 0;
  margin-right: 24px;
}

.product-image {
  position: relative;
  width: 100%;
  padding-top: 100%;
  background-color: #f5f5f5;
  border-radius: 2px;
  overflow: hidden;
}

.product-image .image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.product-image .image ::v-deep .el-image__inner {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.product-info-list {
  flex: 1;
  min-width: 0;
  padding-top: 4px;
}

.product-name-row {
  align-items: flex-start;
  margin-bottom: 8px;
  padding-bottom: 12px;
  border-bottom: 1px solid #f0f0f0;
}

.product-name-row .label {
  line-height: 24px;
}

.product-name {
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  color: #262626;
  word-break: break-all;
}

.info-row {
  display: flex;
  line-height: 28px;
  font-size: 14px;
}

.info-row .label {
  flex-shrink: 0;
  width: 100px;
  color: #999;
}

.info-row .value {
  flex: 1;
  color: #333;
}

.feedback-content {
  padding: 0;
}

.feedback-content ::v-deep .el-table {
  border: none;
}

.drawer-footer {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 12px 24px;
  border-top: 1px solid #eee;
  background-color: #fff;
}

.drawer-footer ::v-deep .el-button {
  height: 32px;
  padding: 0 15px;
  line-height: 32px;
}
</style>

<style>
.channel-reserve-detail-drawer .el-drawer__body {
  position: relative;
  padding-bottom: 60px;
}
</style>
